import { Component } from "@angular/core";
import { Icon } from "../utils/icon/icon";
import { RouterLink } from "@angular/router";
import { TranslocoModule } from "@jsverse/transloco";

@Component({
  selector: "app-footer",
  imports: [Icon, RouterLink, TranslocoModule],
  templateUrl: "./footer.html",
  styles: [
    `
      :host {
        display: block;
        position: relative;
        background-color: var(--color-vinciBlue-600);
        z-index: 0;
      }

      :host::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-image: url("/assets/images/bg/bg-footer.svg");
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        background-attachment: fixed;
        opacity: 0.03;
        z-index: 0;
      }

      :host > * {
        position: relative;
        z-index: 1;
      }

      details .icon-closed {
        display: block;
      }

      details .icon-open {
        display: none;
      }

      details[open] .icon-closed {
        display: none;
      }

      details[open] .icon-open {
        display: block;
      }
    `,
  ],
})
export class Footer {}
